module.exports = __webpack_public_path__ + "static/avatar-5cf0292e23512ffda7a9c24b099babf2.jpg";